module.exports = __webpack_public_path__ + "img/gate_select.54c2514b.png";